import type { Currency } from './types';

export const CURRENCIES: Currency[] = [
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'PLN', symbol: 'zł', name: 'Polish Złoty' },
  { code: 'CHF', symbol: 'CHF', name: 'Swiss Franc' },
  { code: 'NOK', symbol: 'kr', name: 'Norwegian Krone' },
  { code: 'SEK', symbol: 'kr', name: 'Swedish Krona' },
  { code: 'DKK', symbol: 'kr', name: 'Danish Krone' },
  { code: 'CZK', symbol: 'Kč', name: 'Czech Koruna' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
];

export function currencyByCode(code: string): Currency {
  return CURRENCIES.find((c) => c.code === code) ?? CURRENCIES[0];
}

export function formatMoney(value: number, currencyCode: string): string {
  const c = currencyByCode(currencyCode);
  const rounded = Math.round(value);
  const grouped = rounded.toLocaleString('en-US').replace(/,/g, ' ');
  // Symbols that follow the number (cleaner for many European currencies).
  const trailing = new Set(['zł', 'kr', 'Kč']);
  if (trailing.has(c.symbol)) return `${grouped} ${c.symbol}`;
  return `${c.symbol}${grouped}`;
}
